module.exports = __webpack_public_path__ + "assets/img/18@3x.ec76b8fc.png";